import { memo } from 'react';
import { GlowSkeleton } from '@headless-workspace/glow-ds';
import { ComponentMemo } from '@headless-workspace/typings';

export const ConnectionBannerGreetingSkeleton: ComponentMemo = memo(() => {
    return (
        <>
            <GlowSkeleton width={'17.875rem'} height={'2rem'} />
            <GlowSkeleton height={'1.25rem'} containerClassName={'w-full'} />
            <GlowSkeleton height={'1.25rem'} containerClassName={'w-full'} />
            <GlowSkeleton height={'1.25rem'} containerClassName={'w-full'} />
            <GlowSkeleton height={'1.25rem'} width={'17.875rem'} />
        </>
    );
});

ConnectionBannerGreetingSkeleton.displayName = 'ConnectionBannerGreetingSkeleton';
